export const environment = {
  production: false,
  API_END_POINT: 'https://dev.docquityclinic.id',
  indonesiaDomain: 'https://dev.dqcare.id',
  otherDomain: 'https://dev.dqcare.id',
  hCaptchaSiteKey: '10000000-ffff-ffff-ffff-000000000001',
  env : 'DEV',
  hideRelevantFilesPharma: ''
};
